import type { Network } from "../types";

export const bluesky: Network = {
  name: "Bluesky",
  shareUrl: "https://bsky.app/intent/compose?text=[u]",
  icon: "/media/images/social-share-bluesky.png",
  color: "#1185FE",
};
